import { c as _c } from "react/compiler-runtime";
import { EntityRepository } from '@record-it-npm/synchro-client';
import { useCallback } from 'react';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { useGlobalConfirmDeleteDialog } from 'record-it-components/hooks/useGlobalConfirmDeleteDialog';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppEntityManagerEntityTypesByEntityName } from '../../../classes/entities/AppEntityManagerEntityTypesByEntityName';
import { useEntityRepository } from '../useEntityRepository';
export function useEntityDeleteHandlerFactory(opts) {
  const $ = _c(6);
  const getName = useEventCallback(opts.getName);
  const globalConfirmDeleteDialogHandle = useGlobalConfirmDeleteDialog();
  const repository = useEntityRepository(opts.entityName) as EntityRepository<any, any, any>;
  let t0;
  if ($[0] !== repository) {
    t0 = entity => {
      repository.delete(entity);
    };
    $[0] = repository;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleDelete = useEventCallback(t0);
  let t1;
  if ($[2] !== getName || $[3] !== globalConfirmDeleteDialogHandle || $[4] !== handleDelete) {
    t1 = entity_0 => () => {
      globalConfirmDeleteDialogHandle.open({
        item: entity_0,
        getName,
        onDelete: handleDelete
      });
    };
    $[2] = getName;
    $[3] = globalConfirmDeleteDialogHandle;
    $[4] = handleDelete;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
export type UseEntityDeleteHandlerFactoryOptions<TEntityName extends EntityName> = {
  entityName: TEntityName;
  getName: (entity: AppEntityManagerEntityTypesByEntityName[TEntityName]['entity']) => string;
};